var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClimbing = function SvgClimbing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0 9.25 5l2.85 3.8-1.6 1.2C8.81 7.75 6 4 6 4l-6 8h22z"
  })));
};
export { SvgClimbing as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIxMiI+PHBhdGggZD0iTTEzIDAgOS4yNSA1bDIuODUgMy44LTEuNiAxLjJDOC44MSA3Ljc1IDYgNCA2IDRsLTYgOGgyMkwxMyAwWiIvPjwvc3ZnPgo=";